define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/dateUtils", "../../shared/dataLogs", "../../utils/kendoUtils", "../../shared/exportDataWithDetails", "../../shared/exportDataSource", "../../models/TagModel", "../../models/CustomerModel", "../../models/CustomerNoteModel", "../../models/AccountModel", "../../models/CustomerPlanModel", "../../models/CustomerServerGroupModel", "../../models/CustomerContactsModel", "../../models/UserContext", "./customerServersActions", "../customers/customerActions", "../components/DateRangeModel", "./customerImages", "./customerDocuments", "./customerEmployees", "./customerTags", "../customerPortalAdmin/customerUserActions", "../customerPortalAdmin/cpActions", "./customerBillItems", "./customerPbxAccounts", "./customerInvoices", "./customerPayments", "./customerBankingInfo", "../settings/customerNoteCategories", "../../utils/LookupDataSources", "./customerPlans", "./customerPhoneNumbers", "./customerLocations", "./customerRecurringProfiles", "./customerCdrs", "./customerTasks", "./customerFirewallList", "./customerTickets"], function (require, exports, $, ko, log, urls_1, tools, DateUtils, DataLogs, KendoUtils, ExportDataWithDetails, ExportDataSource, TagModel, CustomerModel, CustomerNoteModel, AccountModel, CustomerPlanModel, CustomerServerGroupModel, CustomerContactsModel, UserContext, CustomerServersActions, CustomerActions, DateRangeModel, CustomerImages, CustomerDocuments, CustomerEmployees, CustomerTags, CustomerPortalUsers, CustomerPortalProfiles, CustomerBillItems, CustomerPbxAccounts, CustomerInvoices, CustomerPayments, CustomerBankingInfo, CustomerNoteCategories, LookupDataSources, CustomerPlans, CustomerPhoneNumbers, CustomerLocations, CustomerRecurringProfiles, CustomerCdrs, CustomerTasks, CustomerFirewallList, CustomerTickets) {
    "use strict";
    var CustomerDetails = /** @class */ (function () {
        function CustomerDetails() {
            this.customerId = ko.observable(0);
            this.editModel = ko.observable(new CustomerModel());
            this.editCustomerPlanModel = ko.observable(new CustomerPlanModel());
            this.editAccountModel = ko.observable(new AccountModel());
            this.notesModel = ko.observableArray([]);
            this.noteEditModel = ko.observable();
            this.customerNote = ko.observable("");
            this.editServerGroupModel = ko.observable(new CustomerServerGroupModel());
            this.editCustomerContactModel = ko.observable(new CustomerContactsModel());
            this.customerNoteCategory = ko.observable();
            this.noteNotificationType = ko.observable(1);
            this.showNotificationSection = ko.observable(false);
            this.isImportantNote = ko.observable(false);
            this.noteExpirationDate = ko.observable();
            this.importantNotes = ko.observableArray();
            this.popupNotes = ko.observableArray();
            this.detailsDataSources = [];
            this.userCanEditCustomerServers = ko.observable(UserContext.hasAccess("Admin,CustomerServer.Edit,CustomerServer.Delete"));
            this.userCanViewCustomerServers = ko.observable(UserContext.hasAccess("Admin,CustomerServer.View,CustomerServer.Edit,CustomerServer.Delete"));
            this.userCanDeleteCustomerServers = ko.observable(UserContext.hasAccess("Admin,CustomerServer.Delete"));
            this.userCanEditCustomerContacts = ko.observable(UserContext.hasAccess("Admin,CustomerContacts.Edit,CustomerContacts.Delete"));
            this.userCanViewCustomerContacts = ko.observable(UserContext.hasAccess("Admin,CustomerContacts.View,CustomerContacts.Edit,CustomerContacts.Delete"));
            this.userCanDeleteCustomerContacts = ko.observable(UserContext.hasAccess("Admin,CustomerContacts.Delete"));
            this.userCanEditCustomer = ko.observable(UserContext.hasAccess("Admin,Customers.Edit,Customers.Delete"));
            this.userCanDeleteCustomer = ko.observable(UserContext.hasAccess("Admin,Customers.Delete"));
            this.userCanExportCustomer = ko.observable(UserContext.hasAccess("Admin,Customers.Export"));
            this.userCanViewCustomerBalance = ko.observable(UserContext.hasAccess("Admin,CustomerBalance.View"));
            this.canViewCustomerCdrSummary = ko.observable(UserContext.hasAccess("Admin,CustomerCdrSummary.View"));
            this.userCanViewCustomerPlans = ko.observable(UserContext.hasAccess("Admin,CustomerPlans.View,CustomerPlans.Edit,CustomerPlans.Delete"));
            this.userCanEditCustomerPlans = ko.observable(UserContext.hasAccess("Admin,CustomerPlans.Edit,CustomerPlans.Delete"));
            this.userCanDeleteCustomerPlans = ko.observable(UserContext.hasAccess("Admin,CustomerPlans.Delete"));
            this.userCanViewBilling = ko.observable(UserContext.hasAccess("Admin,Billing.View,Billing.Edit,Billing.Delete"));
            this.userCanEditBilling = ko.observable(UserContext.hasAccess("Admin,Billing.Edit,Billing.Delete"));
            this.userCanViewNotes = ko.observable(UserContext.hasAccess("Admin,CustomerNotes.View,CustomerNotes.Edit,CustomerNotes.Delete"));
            this.userCanEditNotes = ko.observable(UserContext.hasAccess("Admin,CustomerNotes.Edit,CustomerNotes.Delete"));
            this.userCanDeleteNotes = ko.observable(UserContext.hasAccess("Admin,CustomerNotes.Delete"));
            this.canExportBillLines = ko.observable(UserContext.hasAccess("Admin,Accounting.Export"));
            this.userCanViewTags = ko.observable(UserContext.hasAccess("Admin,CustomerTag.View,CustomerTag.Edit,CustomerTag.Delete"));
            this.userCanEditTags = ko.observable(UserContext.hasAccess("Admin,CustomerTag.Edit,CustomerTag.Delete"));
            this.userCanDeleteTags = ko.observable(UserContext.hasAccess("Admin,CustomerTag.Delete"));
            this.userCanUpdateDns = ko.observable(UserContext.hasAccess("Admin,Dns.Edit,Dns.Delete"));
            this.userCanDeleteDns = ko.observable(UserContext.hasAccess("Admin,Dns.Delete"));
            this.deleteDns = ko.observable(false);
            this.customerServersActions = new CustomerServersActions();
            this.customerActions = new CustomerActions();
            this.customerBalances = ko.observableArray([]);
            this.cdrSummary = ko.observableArray([]);
            this.cdrDurationTotal = ko.observable(0);
            this.cdrCostTotal = ko.observable(0);
            this.cdrCustomerCostTotal = ko.observable(0);
            this.filterCdrSummaryModel = new DateRangeModel();
            this.expandedServersIDs = [];
            this.customerSelectContact = ko.observable(true);
            this.customerContactNewId = ko.observable(0);
            this.customerContactWasDeleted = ko.observable(false);
            this.customerSelectedContact = ko.observable();
            this.customerContactId = ko.observable();
            this.customerContactArray = ko.observableArray([]);
            this.categoryIdTemp = ko.observable(0);
            this.customerPlans = new CustomerPlans();
        }
        CustomerDetails.prototype.init = function (id) {
            var self = this;
            self.customerId(id);
            self.customerNoteCategories = new CustomerNoteCategories();
            self.customerTags = new CustomerTags(id);
            self.filterCdrSummaryModel.action = function () {
                self.initCdrSummary();
            };
            self.customerActions.saveCustomerPlanCallback = function () {
                self.planItemsTable.refresh();
            };
            ko.components.register("header-date-range", {
                template: { element: "header-date-range-template" },
                viewModel: { instance: self.filterCdrSummaryModel }
            });
            var getModelCall = tools.ajaxGet({
                url: urls_1.urls.customerGetCustomerById,
                data: { id: id },
                success: function (result) {
                    if (result.Success) {
                        self.editModel(new CustomerModel(result.Data));
                    }
                    else {
                        log.error(result.Error);
                    }
                }
            });
            // Get lookup data:
            var getLookupData = tools.ajaxGet({
                url: "".concat(urls_1.urls.customerGetLookupData, "?customerId=").concat(id),
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                        self.defaultFirewallGroup = data.Data.DefaultGroup;
                        if (data.Data.DefaultNoteCategory) {
                            self.defaultNoteCategory = data.Data.DefaultNoteCategory;
                        }
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
            $.when(getLookupData, getModelCall).done(function () {
                self.customerServersActions.deleteCallback = function () {
                    self.customerGroupsTable.refresh();
                };
                self.customerServersActions.saveCallback = function () {
                    self.customerGroupsTable.refresh();
                };
                $("#contextLoader").hide();
                $("#mainContext").show();
                if (self.userCanViewCustomerServers()) {
                    self.initCustomerGroups();
                }
                self.initCustomerNotes(true);
                self.initNotesActions();
                if (self.userCanViewCustomerContacts()) {
                    self.initCustomerContacts(self.lookupLists.GridStructures.CustomerContactsStructure);
                }
                if (self.userCanEditNotes()) {
                    self.customerNoteCategories.getCustomerNoteCategoryList(function () {
                        self.customerNoteCategory(self.defaultNoteCategory);
                    });
                }
                if (self.userCanViewCustomerPlans()) {
                    self.customerPlans.init(self.customerId(), function () {
                        self.detailsDataSources.push(new ExportDataSource({
                            dataSource: self.customerPlans.plansTable.getGridData().dataSource,
                            structure: self.customerPlans.lookupLists.GridStructures.PlanItemsStructure,
                            title: "Customer Plans"
                        }));
                    });
                }
                self.getCustomerContactsLookup();
                if (self.canViewCustomerCdrSummary()) {
                    self.initCdrSummary();
                }
                if (self.userCanViewCustomerBalance()) {
                    self.getCustomerBalance();
                }
                self.initCustomerPhoneNumbers();
                self.initCustomerOfficeLocations();
                self.initCustomerEmployees();
                self.initCustomerBankingInfo();
                self.initCustomerRecurringProfiles();
                self.initCustomerInvoices();
                self.initCustomerPayments();
                self.initCustomerBillItems();
                self.initCustomerCdrs();
                self.initCustomerTasks();
                self.initCustomerImages();
                self.initCustomerDocuments();
                self.initCustomerFirewallList();
                self.initCustomerPbxAccounts();
                self.initCustomerCPUsers();
                self.initCustomerTickets();
                self.initCustomerLogs();
                ko.applyBindings(self, document.getElementById("ko-main-content"));
                var lookupDataSources = new LookupDataSources();
                self.brandsDS = lookupDataSources.createLookupDataSource("Brands", { pageSize: 10000 });
                self.initBrandsDropdown();
            });
            $(document).ready(function () {
                $("textarea.addEmComment").bind("keyup", function (event) {
                    self.adjustHeight(this);
                });
                $("#accordion").on("shown.bs.collapse", function () {
                    $(window).trigger("resize");
                });
            });
        };
        CustomerDetails.prototype.initCustomerEmployees = function () {
            var self = this;
            self.customerEmployees = new CustomerEmployees(self.customerId(), function (customerEmployeesService) {
                //setup export
                self.detailsDataSources.push(new ExportDataSource({
                    dataSource: customerEmployeesService.customerEmployeesDataSource,
                    structure: customerEmployeesService.employeesGridStructure,
                    title: "Members"
                }));
            });
            var initEmployees = true;
            $("#collapseEmployees").on("shown.bs.collapse", function () {
                console.log("Employees shown");
                if (initEmployees) {
                    initEmployees = false;
                    self.customerEmployees.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerPhoneNumbers = function () {
            var self = this;
            self.customerPhoneNumbers = new CustomerPhoneNumbers(self.customerId(), self.editModel, self.lookupLists, function (customerPhoneNumbersService) {
                self.detailsDataSources.push(new ExportDataSource({
                    dataSource: customerPhoneNumbersService.phoneNumbersDataSource,
                    structure: customerPhoneNumbersService.lookupLists.GridStructures.PhoneNumbersStructure,
                    title: "Phone Numbers"
                }));
                if (customerPhoneNumbersService.userCanViewE911()) {
                    self.detailsDataSources.push(new ExportDataSource({
                        dataSource: customerPhoneNumbersService.e911Datasource,
                        structure: customerPhoneNumbersService.lookupLists.GridStructures.E911DetailsStructure,
                        title: "E911 Details"
                    }));
                }
                customerPhoneNumbersService.phoneActions.removePhoneCallback = function () {
                    self.customerPhoneNumbers.refreshTable();
                    self.initCustomerNotes(false);
                };
                customerPhoneNumbersService.phoneActions.savePhoneCallback = function () {
                    self.customerPhoneNumbers.refreshTable();
                    self.initCustomerNotes(false);
                };
                customerPhoneNumbersService.phoneActions.removeE911Callback = function () {
                    self.customerPhoneNumbers.refreshTable();
                };
                customerPhoneNumbersService.phoneActions.addE911Callback = function () {
                    self.customerPhoneNumbers.refreshTable();
                };
            });
            self.customerPhoneNumbers.phoneActions.init();
            var initPhoneNumbers = true;
            $("#collapsePhoneNumbers").on("shown.bs.collapse", function () {
                console.log("PhoneNumbers shown");
                if (initPhoneNumbers) {
                    initPhoneNumbers = false;
                    self.customerPhoneNumbers.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerOfficeLocations = function () {
            var _this = this;
            this.customerLocations = new CustomerLocations(this.customerId(), this.editModel, this.lookupLists.GridStructures.OfficeLocationStructure, function (customerLocationsService) {
                _this.detailsDataSources.push(new ExportDataSource({
                    dataSource: customerLocationsService.locationsDataSource,
                    structure: _this.lookupLists.GridStructures.OfficeLocationStructure,
                    title: "Office Locations"
                }));
            });
            var initOfficeLocations = true;
            $("#collapseOfficeLocations").on("shown.bs.collapse", function () {
                console.log("Office Locations shown");
                if (initOfficeLocations) {
                    initOfficeLocations = false;
                    _this.customerLocations.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerBankingInfo = function () {
            var self = this;
            self.customerBankingInfo = new CustomerBankingInfo(self.customerId(), null);
            var initBankingInfo = true;
            $("#collapseBankingInfo").on("shown.bs.collapse", function () {
                console.log("Banking Info shown");
                if (initBankingInfo) {
                    initBankingInfo = false;
                    self.customerBankingInfo.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerRecurringProfiles = function () {
            var self = this;
            self.customerRecurringProfiles = new CustomerRecurringProfiles(self.customerId(), self.lookupLists, function (customerRecurringProfilesService) {
                if (customerRecurringProfilesService.userCanExportCustomerRecurringProfiles()) {
                    self.detailsDataSources.push(new ExportDataSource({
                        dataSource: customerRecurringProfilesService.customerRecurringInvoicesDataSource,
                        structure: customerRecurringProfilesService.customerRecurringInvoicesGridStructure,
                        title: "Recurring Profiles"
                    }));
                }
            });
            var initRecurringProfiles = true;
            $("#collapseRecurringInvoices").on("shown.bs.collapse", function () {
                console.log("Recurring Profiles shown");
                if (initRecurringProfiles) {
                    initRecurringProfiles = false;
                    self.customerRecurringProfiles.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerInvoices = function () {
            var self = this;
            self.customerInvoices = new CustomerInvoices(self.customerId(), function (customerInvoicesService) {
                if (customerInvoicesService.userCanExportCustomerInvoices()) {
                    self.detailsDataSources.push(new ExportDataSource({
                        dataSource: customerInvoicesService.customerInvoicesDataSource,
                        structure: customerInvoicesService.customerInvoicesGridStructure,
                        title: "Invoices"
                    }));
                }
            });
            var initInvoices = true;
            $("#collapseInvoices").on("shown.bs.collapse", function () {
                console.log("Invoices shown");
                if (initInvoices) {
                    initInvoices = false;
                    self.customerInvoices.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerPayments = function () {
            var self = this;
            self.customerPayments = new CustomerPayments(self.customerId(), function (customerPaymentsService) {
                if (customerPaymentsService.userCanExportCustomerPayments()) {
                    self.detailsDataSources.push(new ExportDataSource({
                        dataSource: customerPaymentsService.customerPaymentsDataSource,
                        structure: customerPaymentsService.customerPaymentsGridStructure,
                        title: "Payments"
                    }));
                }
            });
            var initPayments = true;
            $("#collapsePayments").on("shown.bs.collapse", function () {
                console.log("Payments shown");
                if (initPayments) {
                    initPayments = false;
                    self.customerPayments.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerBillItems = function () {
            var self = this;
            self.customerBillItems = new CustomerBillItems(self.customerId(), self.lookupLists, function (customerBillItemService) {
                if (customerBillItemService.userCanExportCustomerBillItems()) {
                    self.detailsDataSources.push(new ExportDataSource({
                        dataSource: customerBillItemService.customerBillLinesDataSource,
                        structure: self.lookupLists.GridStructures.CdrBillItemStructure,
                        title: "Bill Lines"
                    }));
                }
            });
            var initBillItems = true;
            $("#collapseBillLines").on("shown.bs.collapse", function () {
                console.log("Bill Items shown");
                if (initBillItems) {
                    initBillItems = false;
                    self.customerBillItems.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerCdrs = function () {
            var self = this;
            self.customerCdrs = new CustomerCdrs(self.customerId(), self.lookupLists, function (customerCdrsService) {
                self.detailsDataSources.push(new ExportDataSource({
                    dataSource: customerCdrsService.customerCdrDataSource,
                    structure: customerCdrsService.customerCdrGridStructure,
                    title: "Call Detail Records"
                }));
            });
            var initCdrs = true;
            $("#collapseCdr").on("shown.bs.collapse", function () {
                console.log("Cdrs shown");
                if (initCdrs) {
                    initCdrs = false;
                    self.customerCdrs.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerTasks = function () {
            var self = this;
            self.customerTasks = new CustomerTasks(self.customerId(), this.lookupLists, function (customerTasksService) {
                self.detailsDataSources.push(new ExportDataSource({
                    dataSource: customerTasksService.customerTasksDataSource,
                    structure: customerTasksService.customerTasksGridStructure,
                    title: "Tasks"
                }));
            });
            var initTasks = true;
            $("#collapseTasks").on("shown.bs.collapse", function () {
                console.log("Tasks shown");
                if (initTasks) {
                    initTasks = false;
                    self.customerTasks.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerImages = function () {
            var self = this;
            self.customerImages = new CustomerImages(self.customerId());
            var initImages = true;
            $("#collapseImages").on("shown.bs.collapse", function () {
                console.log("Images shown");
                if (initImages) {
                    initImages = false;
                    self.customerImages.initImages();
                }
            });
        };
        CustomerDetails.prototype.initCustomerDocuments = function () {
            var self = this;
            self.customerDocuments = new CustomerDocuments(self.customerId(), self.lookupLists, function (customerDocumentsService) {
            });
            var initDocuments = true;
            $("#collapseDocuments").on("shown.bs.collapse", function () {
                console.log("Documents shown");
                if (initDocuments) {
                    initDocuments = false;
                    self.customerDocuments.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerFirewallList = function () {
            var self = this;
            self.customerFirewallList = new CustomerFirewallList(self.customerId(), self.lookupLists, self.defaultFirewallGroup, function (customerFirewallListService) {
                self.detailsDataSources.push(new ExportDataSource({
                    dataSource: customerFirewallListService.customerFirewallDataSource,
                    structure: customerFirewallListService.customerFirewallGridStructure,
                    title: "Firewall"
                }));
            });
            var initFirewall = true;
            $("#collapseFirewall").on("shown.bs.collapse", function () {
                console.log("Firewall shown");
                if (initFirewall) {
                    initFirewall = false;
                    self.customerFirewallList.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerCPUsers = function () {
            var self = this;
            self.customerPortalUsers = new CustomerPortalUsers(self.editModel().CustomerProfileId(), function (customerPortalUserService) {
                self.detailsDataSources.push(new ExportDataSource({
                    dataSource: customerPortalUserService.customerUsersDataSource,
                    structure: customerPortalUserService.cpCustomerUsersStructure,
                    title: "Customer Portal Users"
                }));
            });
            self.customerPortalProfiles = new CustomerPortalProfiles();
            self.customerPortalProfiles.afterSuccess = function () {
                self.customerPortalUsers.customerUserTable.getGridData().dataSource.read();
            };
            var initCustomerPortalUsers = true;
            $("#divCustomerUsers").on("shown.bs.collapse", function () {
                console.log("Customer Portal Users shown");
                if (initCustomerPortalUsers) {
                    initCustomerPortalUsers = false;
                    self.customerPortalUsers.initGridOnShow();
                }
            });
        };
        CustomerDetails.prototype.initCustomerPbxAccounts = function () {
            var self = this;
            self.customerPbxAccounts = new CustomerPbxAccounts(self.customerId(), function (customerPbxService) {
                self.detailsDataSources.push(new ExportDataSource({
                    dataSource: customerPbxService.customerPbxExtensionsDataSource,
                    structure: customerPbxService.pbxExtensionsGridStructure,
                    title: "Customer Pbx Accounts"
                }));
            });
            var initPbxAccounts = true;
            $("#collapsePbx").on("shown.bs.collapse", function () {
                console.log("pbx shown");
                if (initPbxAccounts) {
                    initPbxAccounts = false;
                    self.customerPbxAccounts.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerTickets = function () {
            var self = this;
            self.customerTickets = new CustomerTickets(self.editModel, self.lookupLists, function (customerTickets) {
            });
            var initTickets = true;
            $("#collapseTickets").on("shown.bs.collapse", function () {
                console.log("Tickets shown");
                if (initTickets) {
                    initTickets = false;
                    self.customerTickets.initGrid();
                }
            });
        };
        CustomerDetails.prototype.initCustomerLogs = function () {
            var self = this;
            if (UserContext.hasAccess("Admin,Customers.Logs")) {
                var dataLogs_1 = new DataLogs("Customer", self.customerId());
                var initLogs_1 = true;
                $("#collapseLog").on("shown.bs.collapse", function () {
                    console.log("Logs shown");
                    if (initLogs_1) {
                        initLogs_1 = false;
                        dataLogs_1.initKendoLogs("divLogsTable");
                        self.detailsDataSources.push(new ExportDataSource({
                            dataSource: dataLogs_1.logsTable.getGridData().dataSource,
                            structure: {
                                columns: dataLogs_1.logsTable.getGridData().columns
                            },
                            title: "Logs"
                        }));
                    }
                });
            }
        };
        CustomerDetails.prototype.initBrandsDropdown = function () {
            var self = this;
            self.brandsDropdown = $("input[name=Customer_BrandId]", document.getElementById("ko-main-content")).kendoDropDownList({
                dataSource: self.brandsDS,
                dataTextField: "Text",
                dataValueField: "Id",
                valuePrimitive: true,
                optionLabel: "None",
                filter: "contains",
                change: function (e) {
                    var dataItem = e.sender.dataItem();
                    if (dataItem) {
                        self.editModel().BrandInternalId(dataItem.Id);
                    }
                    else {
                        self.editModel().BrandInternalId("");
                    }
                }
            }).data("kendoDropDownList");
        };
        CustomerDetails.prototype.editCustomerProfile = function () {
            var self = this;
            var id = undefined;
            if (self.editModel().CustomerProfileId()) {
                id = self.editModel().CustomerProfileId();
            }
            self.customerPortalProfiles.editCPCustomerProfile(id, self.editModel().Id(), self.editModel().Name());
        };
        CustomerDetails.prototype.syncCounterPath = function () {
            var self = this;
            var id = undefined;
            if (self.editModel().CustomerProfileId()) {
                id = self.editModel().CustomerProfileId();
            }
            tools.confirmModal({
                title: "Sync CounterPath",
                text: "Are you sure you want to sync this customer CounterPath data?",
                buttonTitle: "Sync",
                type: "info",
                modalOptions: {},
            }, function (modal) {
                $(modal).modal("hide");
                self.customerPortalProfiles.syncCounterPath(id);
            });
        };
        CustomerDetails.prototype.exportCustomer = function () {
            var self = this;
            if (self.userCanExportCustomer()) {
                var exporter = new ExportDataWithDetails();
                var masterDataSource = new ExportDataSource({
                    dataSource: new kendo.data.DataSource({
                        transport: {
                            read: {
                                url: "/Customers/GetCustomers",
                                type: "POST",
                                dataType: "json"
                            }
                        },
                        schema: {
                            model: self.lookupLists.GridStructures.CustomersStructure.model,
                            data: function (response) { return response.Data; },
                            total: "Total",
                            aggregates: "Aggregates",
                            errors: "Errors"
                        },
                        filter: { field: "Id", operator: "eq", value: self.customerId() },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        serverAggregates: false
                    }),
                    structure: self.lookupLists.GridStructures.CustomersStructure,
                    title: "Customer"
                });
                exporter.openExportToExcel("Customer", "Customer", masterDataSource, self.detailsDataSources);
            }
        };
        CustomerDetails.prototype.getCustomerContactsLookup = function () {
            var self = this;
            tools.ajaxGet({
                url: "/CustomerContacts/GetLookupCustomerContacts?customerId=" + self.customerId(),
                success: function (data) {
                    if (data.Success) {
                        self.customerContactArray.remove(function () {
                            return true;
                        });
                        for (var i = 0; i < data.Data.length; i++) {
                            var item = data.Data[i];
                            self.customerContactArray.push(item);
                        }
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
        };
        CustomerDetails.prototype.getCustomerBalance = function () {
            var self = this;
            tools.ajaxGet({
                url: "/Customers/GetCustomerBalanceDetails",
                data: { id: self.customerId() },
                success: function (data) {
                    if (data.Success) {
                        self.customerBalances(data.Data.Balances);
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
        };
        CustomerDetails.prototype.initCdrSummary = function () {
            var self = this;
            var data = {
                startDate: DateUtils.toIsoStringDate(self.filterCdrSummaryModel.startDate()),
                endDate: DateUtils.toIsoStringDate(self.filterCdrSummaryModel.endDate()),
                customerId: self.customerId()
            };
            tools.ajaxGet({
                url: "/CallDetailRecord/GetCustomerCdrSummary",
                data: data,
                success: function (data) {
                    if (data.Success) {
                        self.cdrSummary(data.Data);
                        var duration_1 = 0, cost_1 = 0, customerCost_1 = 0;
                        ko.utils.arrayForEach(self.cdrSummary(), function (item) {
                            duration_1 += item.BilledDuration;
                            cost_1 += item.Cost;
                            customerCost_1 += item.CustomerAmount;
                        });
                        self.cdrDurationTotal(duration_1);
                        self.cdrCostTotal(cost_1);
                        self.cdrCustomerCostTotal(customerCost_1);
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
        };
        CustomerDetails.prototype.saveCustomerClick = function () {
            var self = this;
            self.saveCustomer(false);
        };
        CustomerDetails.prototype.saveCustomerAndCloseClick = function () {
            var self = this;
            self.saveCustomer(true);
        };
        CustomerDetails.prototype.saveCustomer = function (returnToList) {
            var self = this;
            if (self.editModel().Tax1Name() && self.editModel().Tax2Name() &&
                self.editModel().Tax1Name() === self.editModel().Tax2Name()) {
                tools.error("Customer Tax 1 and Tax 2 can not be the same");
                return;
            }
            if (!self.editModel().CustomerTypeId()) {
                tools.error("Customer Type is a required field");
                return;
            }
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            var btn1 = $("#saveCustomer").button("loading");
            var btn2 = $("#saveCustomerAndClose").button("loading");
            tools.ajaxPost({
                url: "/customers/savecustomer",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (returnToList) {
                        window.location.assign(urls_1.urls.customerList);
                    }
                    else {
                        self.editModel(new CustomerModel(result.Data));
                        self.initBrandsDropdown();
                    }
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
                btn2.button("reset");
            });
        };
        CustomerDetails.prototype.addNotes = function () {
            var self = this;
            if (!self.customerNoteCategory()) {
                tools.error("Category must be selected");
                return;
            }
            var btn = $("#addNoteBtn").button("loading");
            var escapedNotes = $("<div/>").text(self.customerNote()).html();
            var obj = {
                Notes: escapedNotes,
                CustomerId: self.customerId(),
                NoteType: "Notes",
                ContactId: self.customerContactId(),
                CategoryId: self.customerNoteCategory()
            };
            if (self.showNotificationSection()) {
                obj["NotificationType"] = self.noteNotificationTypeDropbox.value();
                obj["IsImportant"] = self.isImportantNote();
                obj["ExpirationDate"] = DateUtils.toIsoStringDate(self.noteExpirationDate());
            }
            tools.ajaxPost({
                url: urls_1.urls.customerSaveCustomerNotes,
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    self.customerNote("");
                    self.notesModel.unshift(new CustomerNoteModel(result.Data));
                    tools.success("Notes added successfully");
                    self.initCustomerNotes(false);
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //todo self.saveInProgress(false);
                btn.button("reset");
            });
        };
        CustomerDetails.prototype.viewAll = function () {
            log.log("test root click");
            $("#accordion").find(".accordion-toggle").trigger("click");
            var a = $("#viewHideAll");
            if (a.text() === "Expand All") {
                a.text("Close All");
            }
            else {
                a.text("Expand All");
            }
        };
        CustomerDetails.prototype.addPlan = function () {
            var self = this;
            self.customerPlans.editPlan();
        };
        CustomerDetails.prototype.calculateRates = function () {
            var self = this;
            self.customerActions.openCalculateRates(self.customerId());
        };
        CustomerDetails.prototype.deleteAccountConfirm = function (accountId) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Account",
                text: "Are you sure you want to delete customer account?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteAccount(accountId);
            });
        };
        CustomerDetails.prototype.deleteAccount = function (accountId) {
            var self = this;
            var data = {
                id: accountId
            };
            data["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerAccounts/DeleteAccountConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Account deleted successfully");
                    self.customerAccountsTable.ajax.reload();
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        CustomerDetails.prototype.editCustomerAccount = function (accountId) {
            var self = this;
            self.editAccountModel(new AccountModel());
            tools.editModal({
                title: "Edit Customer Account",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveCustomerAccount(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(accountId)) {
                        getModelCall = tools.ajaxGet({
                            url: urls_1.urls.getCustomerAccountById,
                            data: { id: accountId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editAccountModel(new AccountModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editAccountModel(new AccountModel());
                        self.editAccountModel().CustomerId(self.editModel().Id());
                        self.editAccountModel().CustomerName(self.editModel().Name());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customeraccount-edit-template', data: editAccountModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerDetails.prototype.saveCustomerAccount = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editAccountModel);
            obj["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerAccounts/SaveCustomerAccount",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.customerAccountsTable.ajax.reload();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerDetails.prototype.adjustHeight = function (textarea) {
            var dif = textarea.scrollHeight - textarea.clientHeight;
            if (dif) {
                if (isNaN(parseInt(textarea.style.height))) {
                    textarea.style.height = textarea.scrollHeight + "px";
                }
                else {
                    textarea.style.height = parseInt(textarea.style.height) + dif + "px";
                }
            }
        };
        CustomerDetails.prototype.initCustomerGroupsGrid = function () {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.CustomerServersGroupsStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "240px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,CanLoginAutomatically") && dataItem.IpAddress) {
                        var primaryServer = ko.utils.arrayFirst(dataItem.Servers, function (x) { return (x.IpAddress == dataItem.IpAddress || x.Domain == dataItem.Dns); });
                        console.log(primaryServer);
                        if (primaryServer && primaryServer.LoginTypeName == 'V6') {
                            html += "<a class=\"btn btn-sm btn-success btn-v6-login\" data-ipaddress=\"".concat(dataItem.IpAddress, "\" data-domain=\"").concat(dataItem.Dns, "\" href=\"#\"><i class=\"fa fa-lock \"></i>&nbsp;Login</a>&nbsp;");
                        }
                        else {
                            html += '<a class="btn btn-sm btn-success btn-login" target="_blank" href="/Servers/MultipleLogin?url=' + dataItem.IpAddress + "&domainName=" + dataItem.Dns + '"><i class="fa fa-lock "></i>&nbsp;Login</a>&nbsp;';
                        }
                    }
                    if (UserContext.hasAccess("Admin,CustomerServer.Delete,CustomerServer.Edit")) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i>&nbsp;Edit</a>';
                    }
                    if (UserContext.hasAccess("Admin,CustomerServer.Delete")) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i>&nbsp;Delete</button>';
                    }
                    return html;
                }
            });
        };
        CustomerDetails.prototype.initServersTableColumns = function () {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.CustomerServersStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,CanLoginAutomatically") && dataItem.IpAddress) {
                        console.log(dataItem);
                        if (dataItem.LoginTypeName == 'V6') {
                            html += "<a class=\"btn btn-sm btn-success btn-v6-login\" data-ipaddress=\"".concat(dataItem.IpAddress, "\" data-domain=\"").concat(dataItem.Dns, "\" href=\"#\"><i class=\"fa fa-lock \"></i>&nbsp;Login</a>&nbsp;");
                        }
                        else {
                            html += '<a class="btn btn-sm btn-success btn-login" target="_blank" href="/Servers/MultipleLogin?url=' + dataItem.IpAddress + "&domainName=" + dataItem.Dns + '"><i class="fa fa-lock "></i>&nbsp;Login</a>&nbsp;';
                        }
                    }
                    return '<div class="text-right">' + html + "</div>";
                }
            });
        };
        CustomerDetails.prototype.initCustomerGroups = function () {
            var self = this;
            self.initCustomerGroupsGrid();
            self.initServersTableColumns();
            var gridId = "divServersTable";
            var gridStructure = self.lookupLists.GridStructures.CustomerServersGroupsStructure;
            var columns = gridStructure.columns;
            self.customerGroupsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerServers/GetCustomerGroups?id=" + self.customerId(),
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        }
                    }
                },
                gridOptions: {
                    //toolbar: kendo.template($('#sg-toolbar-template').html()),
                    pageable: false,
                    columns: columns,
                    resizable: true,
                    detailInit: self.initServers.bind(self),
                    dataBound: function (e) {
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.containsObject(self.expandedServersIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.containsObject(self.expandedServersIDs, rowData.Id)) {
                            self.expandedServersIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedServersIDs.length; i++) {
                            if (self.expandedServersIDs[i] === rowData.Id)
                                self.expandedServersIDs.splice(i, 1);
                        }
                    }
                },
                enableExport: {
                    entityName: "ServerGroup",
                    title: "Servers Groups Records",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: gridId,
                showPagerOnTop: false
            };
            self.customerGroupsTable.initGrid(gridOptions);
            self.detailsDataSources.push(new ExportDataSource({
                dataSource: self.customerGroupsTable.getGridData().dataSource,
                structure: gridStructure,
                title: "Servers"
            }));
            self.initCustomerGroupsActions(gridId);
        };
        CustomerDetails.prototype.initCustomerGroupsActions = function (gridId) {
            var self = this;
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                //self.assignServerGroup(data.Id);
                self.customerServersActions.editCustomerDomain(self.customerId(), data.Id, "");
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.customerServersActions.deleteServerGroupConfirm(data);
                event.preventDefault();
            }).on("click", ".btn-v6-login", function (event) {
                var ipaddress = $(event.currentTarget).data('ipaddress');
                var domain = $(event.currentTarget).data('domain');
                self.customerServersActions.loginToServer(ipaddress, domain);
                event.preventDefault();
            });
        };
        CustomerDetails.prototype.initServers = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.CustomerServersStructure;
            $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    data: e.data.Servers,
                    serverPaging: false,
                    serverSorting: false,
                    serverFiltering: false,
                    pageSize: 10000,
                },
                scrollable: false,
                resizable: true,
                sortable: true,
                pageable: false,
                columns: gridStructure.columns,
                dataBound: function (e) {
                },
            }).data("kendoGrid");
        };
        CustomerDetails.prototype.initServersGrid = function () {
            var self = this;
        };
        CustomerDetails.prototype.assignServerGroup = function (id) {
            var self = this;
            self.customerServersActions.editCustomerDomain(self.customerId(), id, self.editModel().Name());
        };
        CustomerDetails.prototype.saveServerGroup = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editServerGroupModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Customers/SaveServerGroup",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.customerGroupsTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerDetails.prototype.initCustomerContacts = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            var nameColumn = ko.utils.arrayFirst(gridStructure.columns, function (column) {
                return column.field === "FullName";
            });
            nameColumn.template = $("#scrollview-template").html();
            var gridId = "tblCustomerContactsKendo";
            self.customerContactsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    scrollable: true,
                    height: 320,
                    pageable: false
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerContacts/GetCustomerContacts",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.customerId = self.customerId();
                                return data;
                            },
                            dataType: "json"
                        }
                    }
                },
                gridId: gridId
            };
            self.customerContactsTable.initGrid(gridOptions);
            self.detailsDataSources.push(new ExportDataSource({
                dataSource: self.customerContactsTable.getGridData().dataSource,
                structure: gridStructure,
                title: "Contacts"
            }));
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editCustomerContact(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteCustomerContactConfirm(data);
                event.preventDefault();
            });
        };
        CustomerDetails.prototype.editCustomerContact = function (id, customerId) {
            var self = this;
            var title = "Add Contact";
            if (!isNaN(id)) {
                title = "Edit Contact";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form               
                    if (!self.editCustomerContactModel().FirstName() &&
                        !self.editCustomerContactModel().LastName()) {
                        tools.error("First or last name is required!");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerContact(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerContacts/GetById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editCustomerContactModel(new CustomerContactsModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editCustomerContactModel(new CustomerContactsModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'cc-edit-template', data: editCustomerContactModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerDetails.prototype.addContactTag = function () {
            var self = this;
            var title = "Add Tag";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (!self.customerTagsDropdown.value()) {
                        tools.error("Tag is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveContactTag(event.currentTarget, modal, self.customerTagsDropdown.value());
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'tag-add-template', data: $root }\"></div>");
                    ko.applyBindings(self, modal);
                    var lookupDataSources = new LookupDataSources();
                    var tagsDS = lookupDataSources.createLookupDataSource("ContactTags");
                    self.customerTagsDropdown = $("input[name=TagId]", modal).kendoDropDownList({
                        dataSource: tagsDS,
                        dataTextField: "Text",
                        dataValueField: "Id",
                        valuePrimitive: true,
                        filter: "contains",
                        popup: {
                            appendTo: $(".modal-body", modal)
                        }
                    }).data("kendoDropDownList");
                }
            });
        };
        CustomerDetails.prototype.deleteContactTag = function (parent, data) {
            var self = this;
            self.editCustomerContactModel().Tags.remove(function (x) {
                return x.Id() == data.Id();
            });
        };
        CustomerDetails.prototype.saveContactTag = function (btn, modal, tagId) {
            var self = this;
            var obj = {
                id: tagId
            };
            tools.ajaxGet({
                url: "/Tag/GetTagById",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    var tag = new TagModel(result.Data);
                    var isExsist = false;
                    for (var _i = 0, _a = self.editCustomerContactModel().Tags(); _i < _a.length; _i++) {
                        var existingTag = _a[_i];
                        if (existingTag.Id() == tag.Id()) {
                            isExsist = true;
                            break;
                        }
                    }
                    if (!isExsist) {
                        self.editCustomerContactModel().Tags.push(tag);
                    }
                    $(modal).modal("hide");
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerDetails.prototype.saveCustomerContact = function (btn, modal) {
            var self = this;
            var tagids = self.editCustomerContactModel().Tags().map(function (x) { return x.Id(); });
            self.editCustomerContactModel().TagIds(tagids.join(','));
            var obj = ko.mapping.toJS(self.editCustomerContactModel);
            obj["CustomerId"] = ko.mapping.toJS(self.customerId);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerContacts/SaveContact",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    if (obj.Id > 0) {
                        tools.success("Changes updated successfully");
                    }
                    else {
                        tools.success("Contact added successfully");
                    }
                    self.customerContactNewId(result.Data.Id);
                    self.customerContactsTable.refresh();
                    self.getCustomerContactsLookup();
                    self.initCustomerNotes(false);
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerDetails.prototype.deleteCustomerContactConfirm = function (contact) {
            var self = this;
            tools.confirmModal({
                title: "Delete contact: " + contact.FullName,
                text: "Are you sure you want to delete this contact ?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerContact(contact.Id);
            });
        };
        CustomerDetails.prototype.deleteCustomerContact = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerContacts/DeleteContact",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Contact deleted successfully");
                    self.customerContactsTable.refresh();
                    self.getCustomerContactsLookup();
                    self.initCustomerNotes(false);
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        CustomerDetails.prototype.initCustomerNotes = function (initial) {
            var self = this;
            var notes = [];
            var categories = [];
            $(".noteTabstrip").empty();
            var dataSource = null;
            var noteData = null;
            noteData = tools.ajaxPost({
                url: "/CustomerNotes/GetCustomerNotesForTabs",
                data: { customerId: self.customerId() },
                success: function (result) {
                    var allCats = [];
                    self.importantNotes.remove(function (x) { return true; });
                    self.popupNotes.remove(function (x) { return true; });
                    categories = result.Data.Categories;
                    ko.utils.arrayForEach(result.Data.Notes, function (note) {
                        note.Notes = tools.urlify(note.Notes);
                        notes.push(note);
                        var noteModel = new CustomerNoteModel(note);
                        if (noteModel.NotificationType() > 0 && (noteModel.ExpirationDate() == null || noteModel.ExpirationDate() >= DateUtils.today())) {
                            if (note.IsImportant) {
                                self.popupNotes.push(noteModel);
                            }
                            else {
                                self.importantNotes.push(noteModel);
                            }
                        }
                    });
                    self.updateImportantNotifications();
                    self.updatePopupNotifications();
                    allCats.push({ Id: 0, Name: "All", Notes: notes });
                    var notesTemp;
                    for (var j = 0; j < categories.length; j++) {
                        notesTemp = [];
                        for (var k = 0; k < notes.length; k++) {
                            if (notes[k].CategoryId === categories[j].Id) {
                                notesTemp.push(notes[k]);
                            }
                        }
                        allCats.push({ Id: categories[j].Id, Name: categories[j].Name, Notes: notesTemp });
                    }
                    dataSource = new kendo.data.DataSource({
                        data: allCats
                    });
                    dataSource.read();
                }
            });
            $.when(noteData).done(function () {
                var tabStrip = $(".noteTabstrip").kendoTabStrip({
                    animation: {
                        open: { effects: "fadeIn" }
                    },
                    scrollable: true,
                    select: function (e) {
                        if ($(e.item).index() !== 0) {
                            self.categoryIdTemp(categories[$(e.item).index() - 1].Id);
                        }
                        var template = kendo.template($("#customer-notes-template").html());
                        var data = e.sender.dataSource.at($(e.item).index());
                        data["canEdit"] = self.userCanEditNotes();
                        data["canDelete"] = self.userCanDeleteNotes();
                        $(e.contentElement).html(template(data));
                    },
                    dataTextField: "Name",
                    dataContentField: "Name",
                    dataSource: dataSource
                }).data("kendoTabStrip");
                var sel = 0;
                for (var i = 0; i < categories.length; i++) {
                    if (categories[i].Id === self.categoryIdTemp()) {
                        sel = i + 1;
                    }
                }
                tabStrip.select(sel);
                if (initial) {
                    $(".noteTabstrip").on("click", ".btn-edit-note", function (e) {
                        var id = $(e.currentTarget).data("id");
                        self.editNote(id);
                    }).on("click", ".btn-remove-note", function (e) {
                        var id = $(e.currentTarget).data("id");
                        self.deleteCustomerNoteConfirm(id);
                    });
                }
            });
        };
        CustomerDetails.prototype.updateImportantNotifications = function () {
            var self = this;
            var html = "";
            ko.utils.arrayForEach(self.importantNotes(), function (note) {
                var noteClass = note.NotificationType() === 1 ? "alert-info" : note.NotificationType() === 2 ? "alert-warning" : note.NotificationType() === 3 ? "alert-danger" : "";
                html += "<div class=\"notification ".concat(noteClass, "\" >").concat(note.Notes(), "<span class=\"notification-close fa fa-times\">&nbsp;</span></div>");
            });
            var $notificationsContainer = $("#notifications-container");
            var wrapperContainer = $("#wrapper");
            $notificationsContainer.html(html);
            var notificationHeight = $notificationsContainer.outerHeight();
            wrapperContainer.css("margin-top", notificationHeight);
            //fixme $(".page-content").css("height", `calc(100vh - ${notificationHeight + 90}px)`);
            if (self.importantNotes().length > 0) {
                $notificationsContainer.show();
            }
            else {
                $notificationsContainer.hide();
                wrapperContainer.css("margin-top", 0);
                //fixme $(".page-content").css("height", `calc(100vh - 90px)`);
            }
        };
        CustomerDetails.prototype.updatePopupNotifications = function () {
            var self = this;
            ko.utils.arrayForEach(self.popupNotes(), function (note) {
                var noteClass = note.NotificationType() === 1 ? "alert-info" : note.NotificationType() === 2 ? "alert-warning" : note.NotificationType() === 3 ? "alert-danger" : "";
                tools.alertModal({
                    title: "Attention!",
                    headerClass: noteClass,
                    html: note.Notes()
                });
            });
        };
        CustomerDetails.prototype.initNotesActions = function () {
            var self = this;
            self.noteNotificationTypeDropbox = $("#note-notification-type").kendoDropDownList({
                dataTextField: "Text",
                dataValueField: "Value",
                valueTemplate: "<div class='bg-#:data.Value#' >#:data.Text#</div>",
                template: "<div class='bg-dropdown bg-#:data.Value#'>#:data.Text#</div>",
                dataSource: {
                    data: self.lookupLists.NoteNotificationTypes
                }
            }).data("kendoDropDownList");
            $("#notifications-container").on("click", ".notification-close", function (event) {
                $(event.currentTarget).closest(".notification").remove();
                var notificationHeight = $("#notifications-container").outerHeight();
                $("#wrapper").css("margin-top", notificationHeight);
                //fixme $(".page-content").css("height", `calc(100vh - ${notificationHeight + 90}px)`);
                if ($("#notifications-container").is(":empty")) {
                    $("#notifications-container").hide();
                    $("#wrapper").css("margin-top", 0);
                    //fixme $(".page-content").css("height", `calc(100vh - 90px)`);
                }
            });
        };
        CustomerDetails.prototype.editNote = function (id) {
            var self = this;
            var title = "Edit Note";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (!self.noteEditModel().CategoryId()) {
                        tools.error("No category selected!");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    var obj = ko.mapping.toJS(self.noteEditModel);
                    obj["ExpirationDate"] = DateUtils.toIsoStringDate(self.noteEditModel().ExpirationDate());
                    obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
                    tools.ajaxPost({
                        url: "/CustomerNotes/EditCustomerNote",
                        data: obj
                    }).done(function (result) {
                        if (result.Success) {
                            tools.success("Changes updated successfully");
                            self.initCustomerNotes(false);
                            $(modal).modal("hide");
                            return;
                        }
                        else {
                            tools.error(result.Error);
                        }
                    }).always(function () {
                        $(event.currentTarget).button("reset");
                    });
                },
                opened: function (modal) {
                    var getModelCall = tools.ajaxGet({
                        url: "/CustomerNotes/GetCustomerNoteById",
                        data: { id: id },
                        success: function (result) {
                            if (result.Success) {
                                self.noteEditModel(new CustomerNoteModel(result.Data));
                            }
                            else {
                                log.error(result.Error);
                                tools.error(result.Error);
                                $(modal).modal("hide");
                            }
                        }
                    });
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'note-edit-template', data: noteEditModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerDetails.prototype.deleteCustomerNoteConfirm = function (noteId) {
            var self = this;
            tools.confirmModal({
                title: "Delete Note",
                text: "Are you sure you want to delete note?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                $.ajax({
                    url: "/CustomerNotes/DeleteCustomerNote",
                    type: "POST",
                    data: { noteId: noteId },
                    success: function (response) {
                        if (response.Success) {
                            tools.success("Note deleted successfully");
                            self.initCustomerNotes(false);
                        }
                        if (response.Error) {
                            tools.error(response.Error);
                        }
                    }
                });
            });
        };
        CustomerDetails.prototype.containsObject = function (a, obj) {
            for (var i = 0; i < a.length; i++) {
                if (a[i] === obj)
                    return true;
            }
            return false;
        };
        return CustomerDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith(urls_1.urls.customerDetails)) {
            var id_1 = urls_1.urls.getIdFromQueryString();
            if (id_1 <= 0) {
                id_1 = urls_1.urls.getIdFromUrl();
            }
            log.log("Initialize Customer Details id: " + id_1);
            $(function () {
                (new CustomerDetails()).init(id_1);
            });
        }
    }, 0);
    return CustomerDetails;
});
//# sourceMappingURL=customerDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerDetails.js
// module id = 154
// module chunks = 2